/*** SCROLL CONTROL ****/
// Hide Header on on scroll down
let didScroll;
let lastScrollTop = 0;
const delta = 5;
const navbarHeight = document.querySelector('header').offsetHeight;

window.addEventListener('scroll', function (event) {
  didScroll = true;
});

document.addEventListener("DOMContentLoaded", function() {
	
	window.addEventListener("beforeunload", function () {
	  document.body.classList.add("fade--out");
	});
	
	window.addEventListener("pageshow", function() {
	  setTimeout(function(){
		document.body.classList.remove("fade--out");
	  }, 250);
	}, false);
	
	setTimeout(function(){
	  document.body.classList.remove("fade--out");
	}, 500);
	
  const lazyElements = document.querySelectorAll('.lazy');

  if ('IntersectionObserver' in window) {
	const observer = new IntersectionObserver(function(entries, obs) {
	  entries.forEach(function(entry) {
		if (entry.isIntersecting) {
		  const el = entry.target;

		  if (el.tagName === 'IMG') {
			setTimeout(function() {
			  el.src = el.dataset.src;
			}, 500);
		  }

		  if (el.tagName === 'VIDEO') {
			// Aseguramos mute y playsinline para autoplay en iOS
			el.muted = true;
			el.playsInline = true;
			el.setAttribute('playsinline', '');
			el.setAttribute('webkit-playsinline', '');

			const playPromise = el.play();
			if (playPromise !== undefined) {
			  playPromise.catch(error => {
				el.controls = true;
				el.classList.add('no-autoplay');
			  });
			}
		  }

		  el.classList.remove('lazy');
		  obs.unobserve(el);
		}
	  });
	});

	lazyElements.forEach(function(el) {
	  observer.observe(el);
	});
  }

});

window.addEventListener('load', function (event) {
  if (window.scrollY < navbarHeight) {
    document.querySelector('body').classList.add('scroll--top');
  } else {
    document.querySelector('body').classList.remove('scroll--top');
  }
});



setInterval(function () {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 125);

function hasScrolled() {
  const st = window.scrollY;

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) return;
  if (window.scrollY < navbarHeight) {
    document.querySelector('body').classList.add('page--top');
  } else {
    document.querySelector('body').classList.remove('page--top');
  }
  if (window.scrollY < 4) {
    document.querySelector('body').classList.add('scroll--top');
    document.querySelector('body').classList.remove('scroll--up');
    document.querySelector('body').classList.remove('scroll--down');
    //document.querySelector('main').style.marginTop = '0px';
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__header').style.top = '0px';
    }
    lastScrollTop = st;
    return;
  } else {
    document.querySelector('body').classList.remove('scroll--top');
    document.querySelector('body').classList.remove('scroll--up');
  }

  if (st > lastScrollTop) {
    // Scroll Down
    document.querySelector('body').classList.remove('scroll--up');
    document.querySelector('body').classList.add('scroll--down');
    //document.querySelector('main').style.marginTop = '0px';
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__header').style.top = '0px';
    }
  } else {
    // Scroll Up
    if (st + window.innerHeight < document.body.scrollHeight) {
      document.querySelector('body').classList.remove('scroll--down');
      document.querySelector('body').classList.add('scroll--up');
    }
    if (window.location.pathname != '/') {
      //document.querySelector('main').style.marginTop = navbarHeight + 'px';
    }
    if (document.querySelector('.collection__header') != null) {
      //document.querySelector('.collection__header').style.top = navbarHeight + 'px';
    }
  }

  lastScrollTop = st;
}

window.addEventListener('load', function () {
  if (document.querySelector('.option__title__guide') != null) {
    document.querySelector('.option__title__guide').addEventListener('click', function () {
      document.querySelector('.popup__guide').classList.add('view');
    });
    document.querySelector('.guide__close').addEventListener('click', function () {
      document.querySelector('.popup__guide').classList.remove('view');
    });
    document.querySelector('.guide__background').addEventListener('click', function () {
      document.querySelector('.popup__guide').classList.remove('view');
    });    
  }

});
